<template>
    <a :href="link">
        <span class="image">
            <img :src="srcImage" @mouseover="srcImage = hoverImage" @mouseout="srcImage = originalImage">
        </span>
    </a>
</template>
<script>
    export default {
        props: {
            srcImg: {
                type: String,
                required: true
            },
            hoverImg: {
                type: String,
                required: true
            },
            link: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                srcImage: this.srcImg,
                hoverImage: this.hoverImg,
                originalImage: this.srcImg
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/src/components/Image/ImageHighlight.vue